export default __webpack_public_path__ + "3c4e9b02f6985c2b39391d8c65c30a57.png";